import { Input, Select } from 'components';
import { Form, Row, Col } from 'antd';
import { DatePicker } from 'components/datePicker';
import moment from 'moment';
import { useOutletContext } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { useCallback, useEffect } from 'react';
import { getAddresFromLatLng, getIdByLabel } from 'utilities';
import { FormInstance } from 'antd/lib';
import { setValues } from '../redux-sagas/actions';
import { WORKER_STATUS } from 'api';
import { useCities } from 'hooks/useCities';
import { useDocumentsType } from 'hooks/useDocumentsType';

export const Step1CompalteProfile = () => {
  const { cities, loadingCities } = useCities();
  const { documentsTypes, loadingDocumentsTypes } = useDocumentsType();
  const { currentLat = null, currentLng = null } = useSelector(
    (state: any) => state.processComplate?.aux || {},
    (a, b) => a.currentLat === b.currentLat || a.currentLng === b.currentLng,
  );
  const cityIdServer = useSelector((state: any) => state.profile.data.cityId);
  const { 0: { cityId: cityIdCurrent = null } = {} } = useSelector(
    (state: any) => state.processComplate.values,
    (a, b) => a[0].cityId === b[0].cityId,
  );

  const dispatch = useDispatch();
  const form = useOutletContext() as FormInstance;
  const userStatus = useSelector((state: any) => state.profile?.data?.state);

  const cleanUpStreetAndNumber = useCallback(() => {
    form.setFieldsValue({ streetNumber: undefined, address: undefined });
  }, []);

  useEffect(() => {
    if (currentLat && !cityIdServer && !cityIdCurrent)
      getAddresFromLatLng(currentLat, currentLng).then((resp) => {
        dispatch(
          setValues({
            step: 0,
            aux: {
              currentCity: resp.city,
              currentState: resp.state,
              currentCountry: resp.country,
            },
          }),
        );
        form.setFieldValue('cityId', getIdByLabel(cities, resp.city));
      });
    else if (cityIdServer || cityIdCurrent)
      form.setFieldValue('cityId', cityIdServer || cityIdCurrent);
  }, [cities, currentLat, currentLng, dispatch, form]);

  return (
    <Form
      disabled={WORKER_STATUS.waitingRevision === userStatus}
      layout={'vertical'}
      form={form}
    >
      <Row gutter={10}>
        <Col span={12}>
          <Form.Item
            name="firstName"
            rules={[{ required: true, message: 'Nombre es requerido' }]}
          >
            <Input
              inputType="secondary"
              maxLength={40}
              label="Nombre"
              placeholder="Nombre"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="lastName"
            rules={[{ required: true, message: 'Apellido es requerido' }]}
          >
            <Input
              inputType="secondary"
              maxLength={40}
              label="Apellido"
              placeholder="Apellido"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={24}>
          <Form.Item
            name="email"
            rules={[
              { required: true, message: 'Email es requerido' },
              { type: 'email', message: 'Email invalido' },
            ]}
          >
            <Input
              disabled
              inputType="secondary"
              maxLength={40}
              label="Email"
              placeholder="Email"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={12}>
          <Form.Item
            name="documentTypeId"
            rules={[{ required: true, message: 'Tipo es requerido' }]}
          >
            <Select
              loading={loadingDocumentsTypes}
              selectType="secondary"
              options={documentsTypes}
              label="Tipo de documento"
              placeholder="Tipo de documento"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="documentNumber"
            rules={[{ required: true, message: 'Documento es requerido' }]}
          >
            <Input
              inputType="secondary"
              type="number"
              maxLength={40}
              label="N° de Documento"
              placeholder="N° de Documento"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={12}>
          <Form.Item
            name="birthday"
            rules={[
              {
                required: true,
                message: 'Fecha de Nacimiento es requerido',
              },
            ]}
          >
            <DatePicker
              disabledDate={(date) => date > moment()}
              format={'DD/MM/YYYY'}
              datePickerType="secondary"
              label="Fecha de Nacimiento"
              placeholder="Fecha de Nacimiento"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="phoneNumber"
            rules={[{ required: true, message: 'Teléfono es requerido' }]}
          >
            <Input
              inputType="secondary"
              type="number"
              maxLength={40}
              label="Teléfono"
              placeholder="Teléfono"
            />
          </Form.Item>
        </Col>
      </Row>
      <Row gutter={10}>
        <Col span={24}>
          <Form.Item
            name="cityId"
            rules={[{ required: true, message: 'Ubicación es requerido' }]}
          >
            <Select
              onChange={cleanUpStreetAndNumber}
              loading={loadingCities}
              selectType="secondary"
              options={cities}
              label="Ubicación"
              placeholder="Ubicación"
            />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={10}>
        <Col span={12}>
          <Form.Item
            name="address"
            rules={[{ required: true, message: 'Calle es requerido' }]}
          >
            <Input
              inputType="secondary"
              maxLength={40}
              label="Calle"
              placeholder="Calle"
            />
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            name="streetNumber"
            rules={[{ required: true, message: 'N° es requerido' }]}
          >
            <Input
              inputType="secondary"
              type="number"
              maxLength={40}
              label="N°"
              placeholder="123"
            />
          </Form.Item>
        </Col>
      </Row>
    </Form>
  );
};
